import React from 'react'

import DialogPausedLocation from '../home/DialogPausedLocation'
import { DialogSelectLocation } from '../register/DialogSelectLocation'
import DialogInviteMembers from '../teams/admin/DialogInviteMembers'
import DialogAcceptDecline from '../teams/invitation/DialogAcceptDecline'
import DialogCreateTeam from '../teams/onboarding/DialogCreateTeam'

const HomeDialogs = ({ locationStatus, isScriptLoaded, isScriptLoadSucceed }) => {
  const showPausedLocationDialog = Boolean(locationStatus?.suspended)
  return (
    <>
      {locationStatus && <DialogPausedLocation open={showPausedLocationDialog} />}
      <DialogSelectLocation
        isScriptLoaded={isScriptLoaded}
        isScriptLoadSucceed={isScriptLoadSucceed}
      />
      <DialogAcceptDecline />
      <DialogCreateTeam />
      <DialogInviteMembers />
    </>
  )
}

export default HomeDialogs
